<template>
  <div class="container" id="official_news_outer" v-if="item != null">
    <news-detail-head v-bind:item="item" />
    <div id="news_rich_context" v-if="itemType == 1 || itemType == 4" v-html="item.content" style="margin-top: 30px;">
    </div>

    <div v-else-if="itemType == 2"
         id="news_detail_video_outer">
      <div style="width: 100%;">
        <video v-if="videoUrl != null"
          id="news_detail_video"
          :autoplay="false"
          controls
          :poster="postImage"
        >
          <source :src="videoUrl">
          您的浏览器不支持 HTML5 video 标签。
        </video>
      </div>
    </div>
    <div v-else id="news_detail_pictures_outer">

      <div v-if="imageList != null">
        <img v-for="(item, index) in imageList" src="" :key="'news_details_' + index" :src="item">
      </div>

<!--      <div class="carousel slide" id="news_detail_pictures" data-interval="false" v-if="imageList != null">-->
<!--        <ol v-if="imageList.length > 0 && !hideForSmallScreen" class="carousel-indicators">-->
<!--          <li class="" v-for="(item, index) in imageList"-->
<!--              data-target="#news_detail_pictures"-->
<!--              :data-slide-to="index"-->
<!--              :class="[index == 0 ? 'active' : '']"-->
<!--          ></li>-->
<!--        </ol>-->
<!--        <div class="carousel-inner" v-if="imageList.length > 1">-->
<!--          <div v-for="(item, index) in imageList"-->
<!--               :class="['item', index == 0 ? 'active' : '']"-->

<!--               :style="{backgroundImage: 'url(\'' + item + '\')',}"-->
<!--          >-->
<!--&lt;!&ndash;            <img :src="item" alt="index + '&#45;&#45;slide' " >&ndash;&gt;-->
<!--          </div>-->

<!--        </div>-->

<!--        <a v-if="imageList.length > 1" class="carousel-control left" href="#news_detail_pictures" role="button" data-slide="prev">-->
<!--          <span class="glyphicon glyphicon-chevron-left" style="color: white;" aria-hidden="true"></span>-->
<!--          <span class="sr-only">Previous</span>-->
<!--        </a>-->
<!--        <a v-if="imageList.length > 1" class="carousel-control right " href="#news_detail_pictures" role="button" data-slide="next">-->
<!--          <span class="glyphicon glyphicon-chevron-right" style="color: white;" aria-hidden="true"></span>-->
<!--          <span class="sr-only">Next</span>-->
<!--        </a>-->

<!--      </div>-->
    </div>
  </div>
</template>

<script>
import GlobalInstance from "../../js/shba";
import NewsDetailHead from "./NewsDetailHead";
import HomeVideoPlay from "../HomeVideoPlay";
// import 'bootstrap/js/carousel';

export default {
  name: "NewsDetail",
  components: {
    NewsDetailHead,
    HomeVideoPlay
  },
  data() {
    return {
      title: '官方消息详情',
      item: null,
      postImage: null,
      videoUrl: null,
      imageList: null,
      hideForSmallScreen: true,
    }
  },
  computed: {
    itemType () {
      if (this.item.type != null) {
        return this.item.type;
      }
      return 1;
    },
    currentMenuItem() {
      return GlobalInstance.methods.currentMenuItem(this.$route);
    },
    newsId() {
      return this.$route.params.newsId;
    },
  },
  mounted() {

    if (this.newsId != undefined && this.newsId != null) {
      this.loadData();
    }

    $(window).resize(this.updateStatus);
    setTimeout(this.updateStatus, 50);

  },
  methods: {
    updateStatus() {
      let pictureWitdh = $('#news_detail_pictures').width();
      if (pictureWitdh >= 400) {
        this.hideForSmallScreen = false
      } else  {
        this.hideForSmallScreen = true
      }
    },

    loadData() {

      let _this = this;
      this.$store.state.http.ajax.vmActivityGet(this.newsId,function (data) {
        let code = data.code;
        if (code == 0) {
          _this.item = data.data;
          _this.dealWithItem();
          return;
        }
        _this.$toast('请求失败！');
      }, function (data) {
        _this.$toast('请求失败，请刷新！');
      });
    },
    dealWithItem() {
      if (this.item == null) {
        return;
      }
      let item = this.item;
      let imageUrls = item.imageUrls;
      if (imageUrls == null || imageUrls == '') {
        return;
      }
      let itemType = this.itemType;

      if (itemType == 2) { // 视频
        let temp = imageUrls.split('?');
        this.postImage = temp[0];
        this.videoUrl = temp[1];
      } else if (itemType == 3) { // 图片


        let reg = new RegExp(/[?,]/,'g');
        let temp = imageUrls.split(reg);
        this.imageList = temp;
      }




      //暂时处理td的样式;
      setTimeout(this.dealWithTempTdStyle, 2000);
    },

    dealWithTempTdStyle() {
      let contentDiv = document.getElementById("news_rich_context");

      let tableList = contentDiv.getElementsByTagName('table');
      for (let item of tableList) {
        item.style.width = 'auto';
        item.style.maxWidth = '100%';
      }

      let list = contentDiv.getElementsByTagName('td');
      for (let item of list) {
        item.style.width = 'auto';
      }
    }
  }

}
</script>

<style scoped>
  #official_news_outer {
    padding-top: 30px;
    padding-bottom: 50px;
  }

  #news_detail_pictures_outer {
    padding-top: 30px;
    padding-top: 50px;
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex-wrap: nowrap;

  }

  #news_rich_context /deep/ table {
    width: auto;
    max-width: 100%;
  }


  /*#news_rich_context /deep/ element.style {*/
  /*  width: auto!important;*/
  /*}*/

  #news_rich_context /deep/ table td, #news_rich_context /deep/ table th  {
    background-color: white;
    border: solid 1px #000;
    width: auto;
  }

  #news_detail_pictures_outer::after {
    width: auto;
  }


  @media screen and (max-width: 767px) {
    #news_rich_context /deep/ img {
      max-width: 100%;
      height: auto;
      text-indent: 0;
      margin: auto;
      padding: 0;
    }
  }

  /*#news_detail_pictures_outer > div {*/
  /*  width: 100%;*/
  /*  display: flex;*/
  /*  flex-direction: column;*/
  /*  flex-wrap:nowrap;*/
  /*  justify-content: center;*/
  /*  align-items: flex-start;*/
  /*}*/

  #news_detail_pictures_outer > div img {
    width: auto;
    max-width: 100%;
    display: block;

    height: auto;
    margin: auto;
  }

  #news_detail_pictures_outer > div img:not(:first-child) {
    margin-top: 20px;
  }



  /*#news_detail_pictures {*/
  /*  position: relative;*/
  /*  width: 100%;*/
  /*}*/

  /*#news_detail_pictures .carousel-inner {*/
  /*  width: 100%;*/
  /*  height: 70vh;*/
  /*  position: relative;*/
  /*}*/

  /*#news_detail_pictures .carousel-inner > div {*/
  /*  width: 100%;*/
  /*  height: 100%;*/
  /*  position: relative;*/
  /*  !*background-image: url("../assets/shl_menu_mail_bg.png");*!*/
  /*  background-repeat: no-repeat;*/
  /*  background-size: 100% auto;*/
  /*  background-position: 0 center;*/
  /*  overflow: hidden;*/
  /*}*/

  /*#news_detail_pictures .carousel-inner img {*/
  /*}*/

  /*#news_detail_pictures .carousel-indicators {*/
  /*  position: absolute;*/
  /*  bottom: 0px;*/
  /*  left: 50%;*/
  /*  z-index: 15;*/
  /*  width: 60%;*/
  /*  padding-left: 0;*/
  /*  margin-left: -30%;*/
  /*  text-align: center;*/
  /*  list-style: none;*/
  /*}*/

  /*#news_detail_pictures .carousel-indicators li {*/
  /*  display: inline-block;*/
  /*  width: 20px;*/
  /*  height: 4px;*/
  /*  text-indent: -999px;*/
  /*  cursor: pointer;*/
  /*  background-color: #fff \9;*/
  /*  background-color: white;*/
  /*  border: none;*/
  /*}*/

  /*#news_detail_pictures .carousel-indicators li:not(:first-child) {*/
  /*  margin-left: 10px;*/
  /*}*/

  /*#news_detail_pictures .carousel-indicators .active {*/
  /*  width: 20px;*/
  /*  height: 4px;*/
  /*  !*margin: 0;*!*/
  /*  margin-bottom: 1px;*/
  /*  background-color: #fc1a34;*/
  /*}*/

  #news_detail_video_outer {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 30px 0 0px 0;
    margin-top: 10vh;
    /*background-color: yellow;*/
  }




  @media screen and (min-width: 769px) {
    #news_detail_video_outer {
      margin-top: 10vh;
    }
  }

  @media screen and (min-width: 1025px) {
    #news_detail_video_outer {
      margin-top: 0;
    }
  }

  #news_detail_video_outer > div {
    width: 100%;
  }

  #news_detail_video_outer video {
    width: 100%;
    height: auto;
  }

  @media screen and (min-width: 768px){
    #official_news_outer {
      padding-top: 50px;
      /*padding-bottom: 50px;*/
    }

    #news_detail_video_outer > div {
      width: 70%;
    }


    /*#news_detail_pictures {*/
    /*  !*width: 80%;*!*/
    /*}*/
  }

  /*.carousel-control.left {*/

  /*  background-image:none !important;*/
  /*  background-repeat: repeat-x;*/
  /*  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#80000000', endColorstr='#00000000', GradientType=1);*/
  /*}*/
  /*.carousel-control.right {*/
  /*  left: auto;*/
  /*  right: 0;*/

  /*  background-image:none !important;*/
  /*  background-repeat: repeat-x;*/
  /*  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#00000000', endColorstr='#80000000', GradientType=1);*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/news/NewsDetail.vue